import { useMemo } from 'react';

import { useListContext } from 'react-admin';
import { FormProvider } from 'react-hook-form';
import { FilterContextProvider } from 'shared/mui/Filter/context/filterContext';
import {
  FilterApplyButton,
  FilterButton,
  FilterClearButton,
  FilterResetButton,
} from 'shared/mui/Filter/FilterButtons';
import { FilterChipsToolbar } from 'shared/mui/Filter/FilterChipsToolbar/FilterChipsToolbar';
import {
  FilterDrawer,
  FilterDrawerActionsButtons,
  FilterDrawerContent,
} from 'shared/mui/Filter/FilterDrawer';
import { FilterToolbar } from 'shared/mui/Filter/FilterToolbar/FilterToolbar';
import { useFilters } from 'shared/mui/Filter/hooks/useFilters';
import { useSyncFilter } from 'shared/mui/Filter/hooks/useSyncFilter';
import { cleanEmpty } from 'utils/cleanEmpty';

import { ProviderAccountsListFilterChips } from './ProviderAccountsListFilterChips';
import { ProviderAccountsListFilterForm } from './ProviderAccountsListFilterForm';

type ProviderAccountsFilterValues = {
  company: string[];
  merchants: string[];
  provider: string[];
  workTeam: string;
  members: string[];
};

export const DEFAULT_VALUES = {
  company: [],
  merchants: [],
  provider: [],
  workTeam: '',
  members: [],
};

export const ProviderAccountsListFilter: React.FC = () => {
  const { filterValues } = useListContext();
  const { form, appliedFilters, setAppliedFilter, onSubmit, onReset, openDrawer, toggleDrawer } =
    useFilters<ProviderAccountsFilterValues>({
      defaultValues: {
        company: filterValues.company || [],
        merchants: filterValues.merchants || [],
        provider: filterValues.provider || [],
        members: filterValues.members || [],
        workTeam: filterValues.workTeam || '',
      },
      resetValues: DEFAULT_VALUES,
    });

  useSyncFilter<ProviderAccountsFilterValues>({ appliedFilters });

  const listFilters = useMemo(() => {
    return cleanEmpty(appliedFilters, false);
  }, [appliedFilters]);

  const isListFilterExist = Object.keys(listFilters).length > 0;

  return (
    <>
      <FilterToolbar
        leftActionsSlot={[<FilterButton key="filter" onClick={toggleDrawer(true)} />]}
      />
      <FilterDrawer onClose={toggleDrawer(false)} open={openDrawer}>
        <FormProvider {...form}>
          <form onSubmit={form.handleSubmit(onSubmit)}>
            <FilterDrawerContent>
              <ProviderAccountsListFilterForm />
            </FilterDrawerContent>
            <FilterDrawerActionsButtons>
              <FilterResetButton label="Очистить" onReset={onReset} />
              <FilterApplyButton type="submit" />
            </FilterDrawerActionsButtons>
          </form>
        </FormProvider>
      </FilterDrawer>
      <FilterChipsToolbar appliedFilters={appliedFilters} isSkipBooleanValues={false}>
        <FilterContextProvider appliedFilters={appliedFilters} setAppliedFilter={setAppliedFilter}>
          <FormProvider {...form}>
            <ProviderAccountsListFilterChips />
            <FilterClearButton
              key="clear"
              onClick={() => {
                onReset();
              }}
              visible={isListFilterExist}
            />
          </FormProvider>
        </FilterContextProvider>
      </FilterChipsToolbar>
    </>
  );
};
